import { PopoverPlacement } from '@trarc/pc-shared';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ActionMenuTriggerContainer,
  ActionMenuTriggerIcon,
  ActionMenuTriggerLabel,
  StyledPopoverButton,
} from './ActionMenu.styles';

export interface DetailsActionMenuProps {
  children: ReactNode;
  isOpen: boolean;
  onOpenChange: () => void;
  className?: string;
  disabled?: boolean;
}
export const DetailsActionMenu = ({ children, isOpen, onOpenChange, className, disabled }: DetailsActionMenuProps) => {
  const { t } = useTranslation();

  return (
    <StyledPopoverButton
      placement={PopoverPlacement.BottomRight}
      triggerDisplay={
        <ActionMenuTriggerContainer $isOpen={isOpen}>
          <ActionMenuTriggerLabel>{t('actionsMenu')}</ActionMenuTriggerLabel>
          <ActionMenuTriggerIcon $isOpen={isOpen} />
        </ActionMenuTriggerContainer>
      }
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className={className}
      disabled={disabled}
    >
      {children}
    </StyledPopoverButton>
  );
};
